// Missing account_kind preserves older person-directory projections.
export const peopleOnly = rows => (Array.isArray(rows) ? rows : []).filter(row => row.account_kind !== 'service');
export const personPresetsOnly = rows => (Array.isArray(rows) ? rows : []).filter(row => !String(row.preset_key || '').startsWith('service_'));
